<div [ngClass]="{
  'outer-text-content-without-bc': loginDetails && (loginDetails.customer.registrationStatus || loginDetails.customer.reviewStatus),
  'outer-text-content': !(loginDetails && (loginDetails.customer.registrationStatus || loginDetails.customer.reviewStatus))
}">
  <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
    <form [formGroup]="registrationDetailForm" autocomplete="off" role="form" class=" ">
      <div class="float-left bg-white">

        <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true'
          (onBackClickHandler)="backtoPrevious()"></app-content-top-nav>
        <div class="col-md-12 clear-all title-wrapper">
          <h1 class="title-text custom-header-h2 responsive-text-8" id="registratiion-header">{{loginDetails &&
            (loginDetails.customer.registrationStatus || loginDetails.customer.reviewStatus) ?
            contentData.updateHeadingText : contentData.header}} </h1>
        </div>

        <ng-template #anonymousMessage>
          <p id="registration-message" class="inner-content-data-reg">{{contentData.privacyPolicy}}</p>
          <div class="privacy-policy">
            <a target="_blank" class="pad" href="{{contentData.privacyPolicyLink}}">
              <span class="inner-content-data-reg-priv-txt">{{contentData.privacyPolicyText}}</span>
            </a>
          </div>
        </ng-template>
        <!--Personal detail page-->
        <div class="col-md-12 wrapperMargin content-wrapper ">
          <div
            *ngIf="loginDetails && (loginDetails.customer.registrationStatus || loginDetails.customer.reviewStatus); else anonymousMessage"
            class="col-md-12 mar-tlr-40 bg-lightblue new_padding">
            <p class="inner-content-data pad-lr-0" id="registration-message">{{contentData.messageBox}}</p>
          </div>
          <div class="col-md-5 clear-all" [ngClass]="{
            'pd-top-update': loginDetails && (loginDetails.customer.registrationStatus || loginDetails.customer.reviewStatus),
            'pd-top': !(loginDetails && (loginDetails.customer.registrationStatus || loginDetails.customer.reviewStatus))
          }">
          <!-- <div class="col-md-5 clear-all pd-top"> -->

            <app-dropdown [dropdownConfig]="titleConfig" [pageName]="'registration'" [controlName]="'userTitle'"
              [parent]="registrationDetailForm" (onChangeHandler)="detectChange()">
            </app-dropdown>
          </div>

          <div class="col-md-12 clear-all margin-top-30 form-field" *ngIf="enableOtherTitle">
            <div class="form-field col-md-5 clear-all" [ngClass]="{'has-error': registrationDetailForm.get('otherTitle').touched
          && registrationDetailForm.get('otherTitle').errors}">
              <div class="dropdown-control">
                <label id="othTitle"> {{contentData.otherTitle }}</label>

              </div>
              <div class="form-field-select">
                <select id="registration-otherTitle" formControlName="otherTitle" class="form-control some"
                  aria-invalid="false"
                  [ngModel]="registrationDetails && registrationDetails.otherTitle ? registrationDetails.otherTitle : null">
                  <option [disabled]="false" [ngValue]="null">Please select</option>
                  <option *ngFor="let otherTitle of otherTitleList" [value]="otherTitle.description">
                    {{otherTitle.description}}</option>
                </select>
                <i class="icon icon-chevron-down" aria-hidden="true"></i>
              </div>

              <div class="form-validation-error" *ngIf="registrationDetailForm.get('otherTitle').touched
                                && registrationDetailForm.get('otherTitle').errors 
                                && registrationDetailForm.get('otherTitle').hasError('required')">
                <i class="icon icon-error" aria-hidden="true"></i>
                <p>{{CMSData.string_OtherTitleErrorMessageWording}}</p>
              </div>
            </div>
          </div>

          <div class="col-md-12 clear-all margin-top-30">
            <ng-container
              *ngIf="!loginDetails || (loginDetails && !loginDetails.customer.registrationStatus && !loginDetails.customer.reviewStatus) ; else fName">
              <div class="col-md-5 clear-all">
                <app-nametext-input [pageName]="'register'" [controllerData]="fnameTextCodeConfig"
                  [parent]="registrationDetailForm" [controlName]="'forename'" formControlName="forename"
                  (textChangeEventEmitter)="txtChange()">
                </app-nametext-input>
              </div>

              <div class="col-md-2 mrg-top pd-lr-0 ">
                <app-tool-tip-notification [childId]="'firstNameToolTipInfoCodeConfig'"
                  [tooltipData]="firstNameToolTipInfoCodeConfig" [contentData]="contentData"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage('firstname')"></app-tool-tip-notification>

              </div>
            </ng-container>
            <ng-template #fName>
              <!-- <div class="col-md-5 clear-all">
                      <p class="question-font">{{cmsData.firstName}}</p>
                    </div>
                    <div class="col-md-5 clear-all">
                      <div class="col-md-2 clear-all">
                        <p class="text-color values-font">{{loginDetails.forename}}</p>
                      </div>
                      <div class="col-md-2 mrg-top">
                          <app-tool-tip-notification [childId]="'firstNameToolTipInfoCodeConfig'" [tooltipData]="firstNameToolTipInfoCodeConfig"></app-tool-tip-notification>
                        </div>
                    </div> -->
              <div class="col-md-7 clear-all">
                <p class="question-font">{{contentData.firstName}}</p>
                <div>
                  <div class="col-md-4 clear-all">
                    <p class="text-color values-font">{{customerDetail.forename}}</p>
                  </div>
                <div class="col-md-3 margin-top-3">
                  <app-tool-tip-notification [childId]="'firstNameToolTipInfoCodeConfig'" 
                  [tooltipData]="firstNameToolTipInfoCodeConfig" 
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage('firstname')"></app-tool-tip-notification>
                </div>
                </div>
              </div>
           </ng-template>   
        </div>

        <ng-container *ngIf="!loginDetails || (loginDetails && !loginDetails.customer.registrationStatus && !loginDetails.customer.reviewStatus)">
          <div class="col-md-12 clear-all margin-top-30">
            <div class="col-md-5 clear-all">
              <app-nametext-input [pageName]="'register'" [controllerData]="middleNameTextCodeConfig" [parent]="registrationDetailForm"
                [controlName]="'middleName'" formControlName="middleName" (textChangeEventEmitter)="txtChange()">
              </app-nametext-input>
            </div>

              <div class="col-md-2"></div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="(loginDetails && loginDetails.customer.registrationStatus) || (loginDetails && loginDetails.customer.reviewStatus)">
            <div class="col-md-12 clear-all margin-top-30"
              *ngIf="(registrationDetails.middleName || registrationDetails.thirdName)">
              <div class="col-md-5 clear-all" *ngIf="registrationDetails.middleName">
                <p class="question-font">{{contentData.secondName}}</p>
                <p class="text-color values-font">{{customerDetail.middleName}}</p>
              </div>
              <div class="col-md-2" *ngIf="registrationDetails.middleName"></div>
            </div>
          </ng-container>
         
        <ng-container *ngIf="(loginDetails && loginDetails.customer.registrationStatus) || (loginDetails && loginDetails.customer.reviewStatus)">
          <div class="col-md-12 clear-all margin-top-30" *ngIf="(registrationDetails.middleName)">
            <div class="col-md-5 clear-all" *ngIf="registrationDetails.middleName">
              <p class="question-font">{{contentData.secondName}}</p>
              <p class="text-color values-font">{{customerDetail.middleName}}</p>
            </div>
            <div class="col-md-2" *ngIf="registrationDetails.middleName"></div>
          </div>
        </ng-container>

        <div class="col-md-5 clear-all margin-top-30">
          <ng-container *ngIf="!loginDetails || (loginDetails && !loginDetails.customer.registrationStatus && !loginDetails.customer.reviewStatus); else surName">
            <app-nametext-input [pageName]="'register'" [controllerData]="lnameTextCodeConfig" [parent]="registrationDetailForm" [controlName]="'surname'"
              formControlName="surname" (textChangeEventEmitter)="txtChange()">
            </app-nametext-input>
          </ng-container>
          <ng-template #surName>
            <div class="col-md-5 clear-all">
              <p class="question-font">{{contentData.lastName}}</p>
              <p class="text-color values-font">{{customerDetail.surname}}</p>
            </div>
          </ng-template>
        </div>
        
        <ng-container *ngIf="(loginDetails && loginDetails.customer.registrationStatus) || (loginDetails && loginDetails.customer.reviewStatus)">
          <div class="col-md-12 clear-all margin-top-30" *ngIf="(registrationDetails.thirdName)">
            <div class="col-md-5 clear-all" *ngIf="registrationDetails.thirdName">
              <p class="question-font">{{contentData.thirdName}}</p>
              <p class="text-color values-font">{{customerDetail.thirdName}}</p>
            </div>
          </div>
        </ng-container>
        <!--Name section ends-->

          <ng-container
            *ngIf="!loginDetails || (loginDetails && !loginDetails.customer.registrationStatus && !loginDetails.customer.reviewStatus); else DOB">
            <div class="col-md-12 clear-all">
              <div class="col-md-12 clear-all margin-top-30 ">
                <div class="col-md-12 clear-all">
                  <div class="col-md-7 clear-all">
                    <app-date-input [minAge]="'54.9'" (onBlurHandler)="checkDataChange($event)" [pageName]="'register'"
                      [parent]="registrationDetailForm" [controllerData]="dobCodeConfig" formControlName="dateOfBirth"
                      [tooltipData]="dobInformationConfig">
                    </app-date-input>
                  </div>
                  <div class="col-md-2 margin-top-2 dobInformation mrg-left-tooltip pd-lr-0 ">
                    <app-tool-tip-notification [childId]="'dobInformationConfig'" [tooltipData]="dobInformationConfig"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage('dob')"></app-tool-tip-notification>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #DOB>
            <div class="col-md-12 clear-all margin-top-30">
              <p class="question-font">{{contentData.dateOfBirth}}</p>
            </div>
            <div class="col-md-12 clear-all">
              <div class="col-md-2 clear-all">
                <p class="text-color values-font">{{dobVal}}</p>
              </div>
              <div class="col-md-10 clear-all info-tool-tip-3">
                <app-tool-tip-notification [childId]="'dobInformationConfig'" [tooltipData]="dobInformationConfig"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage('dob')"></app-tool-tip-notification>
              </div>
            </div>
          </ng-template>


          <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()"
            (primaryBtnClick)="alertPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()"
            [saveDataFlag]="false"></app-modal>

          <app-modal *ngIf="ageValidatorFlag" [modalConfig]="ageAlertModalConfig" (closeModal)="closeAgeModal()"
            (primaryBtnClick)="alertAgePrimaryBtnClick()" (secondaryBtnClick)="alertAgeSecondaryBtnClick()"
            [saveDataFlag]="false"></app-modal>

          <app-modal *ngIf="ukAddressCheckFlag" [modalConfig]="ukAddressAlertModalConfig"
            (closeModal)="closeUkAddressModal()" (primaryBtnClick)="alertUkAddressPrimaryBtnClick()"
            (secondaryBtnClick)="alertUkAddressSecondaryBtnClick()" [saveDataFlag]="false"
            (dontShowUpMsgAgain)="dontShowUPMsgAgain($event)"></app-modal>

          <app-modal *ngIf="showRegistrationAlerts" [modalConfig]="directUserModalConfig"
            (closeModal)="closeAuthUserModal(nextPath)" (primaryBtnClick)="alertAuthUserPrimaryBtnClick(nextPath)"
            (secondaryBtnClick)="alertAuthUserSecondaryBtnClick(nextPath)" [saveDataFlag]="false"
            (dontShowUpMsgAgain)="dontShowUPMsgAgain($event)"></app-modal>

          <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
            (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
            [tooltipFlag]="true"></app-modal>


          <ng-container
            *ngIf="!loginDetails || (loginDetails && !loginDetails.customer.registrationStatus && !loginDetails.customer.reviewStatus); else Gender">
            <div class="col-md-12 clear-all">
              <div class="col-md-12 clear-all margin-top-30">
                <div class="col-md-5 clear-all">
                  <app-dropdown [dropdownConfig]="genderConfig" [pageName]="'registration'" [controlName]="'gender'"
                    [parent]="registrationDetailForm">
                  </app-dropdown>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #Gender>
            <div class="col-md-12 clear-all margin-top-30">
              <p class="question-font">{{contentData.gender}}</p>
            </div>
            <div class="col-md-2 clear-all">
              <p class="text-color values-font">{{genderVal}}</p>
            </div>
          </ng-template>

          <div class="col-md-12 clear-all margin-top-30">
            <div class="col-md-5 clear-all">
              <app-dropdown [dropdownConfig]="maritalStatusConfig" [pageName]="'registration'"
                [controlName]="'maritalStatus'" [parent]="registrationDetailForm">
              </app-dropdown>
            </div>
          </div>

          <!--  UK Address Section starts-->
          <ng-container
            *ngIf="!loginDetails || (loginDetails && !loginDetails.customer.registrationStatus && !loginDetails.customer.reviewStatus); else UKAddress">
            <div class="col-md-12 clear-all"> <!-- margin-top to be removed-->
              <div>
                <!-- <span class="form-label font-weight-color" id="ukAddress">{{cmsData.ukaddressIndicator}}</span> -->
                <div class="remove-pading">
                  <app-question [questiontextRequired]="true" [childId]="'ukaddressIndicator'"
                    [questionConfig]="userInputDetail.radioButtonIsUKAddressConfig" [parent]="registrationDetailForm"
                    [controlName]="'ukaddressIndicator'" (toggleChange)="toggleContainer($event)"
                    (onDisplayMobileTooltipEmitter)="displayTooltipMessage('citizen')">
                  </app-question>
                </div>
              </div>
            </div>
         
            <div class="col-md-12 clear-all margin-top-30">
              <div *ngIf="!addressSeachEnabled" class="addPadd">
                <div class="col-md-12 clear-all">
                  <div class="col-md-5 clear-all">

                    <app-addressLines [pageName]="'register'" [controllerData]="addressLine1CodeConfig"
                      [parent]="registrationDetailForm" [controlName]="'addressline1'">
                    </app-addressLines>
                  </div>
                </div>



                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">

                    <app-addressLines [pageName]="'register'" [controllerData]="addressLine2CodeConfig"
                      [parent]="registrationDetailForm" [controlName]="'addressline2'">
                    </app-addressLines>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">
                    <app-addressLines [pageName]="'register'" [controllerData]="addressLine3CodeConfig"
                      [parent]="registrationDetailForm" [controlName]="'addressline3'">
                    </app-addressLines>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30">
                  <div class="col-md-5 clear-all">
                    <app-addressLines [pageName]="'register'" [controllerData]="addressLine4CodeConfig"
                      [parent]="registrationDetailForm" [controlName]="'addressline4'">
                    </app-addressLines>
                  </div>
                </div>
                <div class="col-md-12 clear-all margin-top-30" *ngIf="!overseasCustomer">
                  <div class="col-md-5 clear-all">
                    <app-postcode [postCodeConfig]="postCodeConfig" [controlName]="'postcode'"
                      formControlName="postcode" [parent]="registrationDetailForm" [required]="'true'">
                    </app-postcode>
                  </div>

                </div>
                <div class="mt-10 float-left" *ngIf="!overseasCustomer">
                  <!-- <p id="address-manual-p">
                        <a id="address-manual" (click)="onAddressSeachClick()" class="clickHere mr-7">
                          {{cmsData.click}}</a>
                          {{cmsData.anotherAddress}}
                      </p> -->
                  <p class="font-weight-300 font-size subtitle clear-all" id="address-manual-p">
                    <strong>
                      <a id="address-manual" (click)="onAddressSeachClick()" class="clickHere mr-7" role="button"
                        tabindex="0">
                        {{contentData.anotherAddress}} </a>
                    </strong>
                    <!-- {{contentData.anotherAddress}} -->
                  </p>
                </div>
              </div>


              <div *ngIf="addressSeachEnabled">
                <div class="col-md-12 clear-all">
                  <div class="col-md-5 clear-all">
                    <app-address-search (onSelecteAddress)=onSelecteAddress($event) [parent]="registrationDetailForm"
                      [pageName]="'registration'"></app-address-search>
                  </div>
                </div>
                <div>
                  <!-- {{contentData.addManually}} -->

                  <p class="font-weight-300 font-size subtitle clear-all" id="address-qas-p">
                    <strong>
                      <a id="address-qas" (click)="onManualClick()" class="clickHere mr-7" role="button" tabindex="0">
                        {{contentData.addManually}} </a>
                    </strong>

                  </p>
                </div>

              </div>
            </div>
          </ng-container>

          <ng-template #UKAddress>
            <div class="col-md-12 clear-all margin-top-30">
              <div class="col-md-3 clear-all">
                <p class="question-font">{{contentData.ukaddressIndicator}}</p>
              </div>
              <div class="col-md-9 clear-all info-tool-tip-3">
                <app-tool-tip-notification [childId]="'ukAddressConfig'"
                  [tooltipData]="userInputDetail.radioButtonIsUKAddressConfig.infoIconData"
                  (onDisplayMobileTooltipEmitter)="displayTooltipMessage('citizen')"></app-tool-tip-notification>
              </div>
            </div>
            <div class="col-md-12 clear-all">
              <p class="text-color values-font">{{ukAddressIndicatiorVal}}</p>
            </div>


            <div class="col-md-12 clear-all margin-top-30">
              <p class="question-font">{{contentData.addressline1}}</p>
            </div>
            <div class="col-md-12 clear-all">
              <p class="text-color values-font">{{customerDetail.address.line1}}</p>
            </div>

            <ng-container *ngIf="customerDetail.address.line2">
              <div class="col-md-12 clear-all margin-top-30">
                <p class="question-font">{{contentData.addressline2}}</p>
              </div>
              <div class="col-md-12 clear-all">
                <p class="text-color values-font">{{customerDetail.address.line2}}</p>
              </div>
            </ng-container>
            <ng-container *ngIf="customerDetail.address.line3">
              <div class="col-md-12 clear-all margin-top-30">
                <p class="question-font">{{contentData.addressline3}}</p>
              </div>
              <div class="col-md-12 clear-all">
                <p class="text-color values-font">{{customerDetail.address.line3}}</p>

              </div>
            </ng-container>
            <ng-container *ngIf="customerDetail.address.line4">
              <div class="col-md-12 clear-all margin-top-30">
                <p class="question-font">{{contentData.addressline4}}</p>
              </div>
              <div class="col-md-12 clear-all">
                <p class="text-color values-font">{{customerDetail.address.line4}}</p>
              </div>
            </ng-container>
            <div class="col-md-12 clear-all margin-top-30">
              <p class="question-font">{{contentData.postcode}}</p>
            </div>
            <div class="col-md-12 clear-all">
              <p class="text-color values-font">{{customerDetail.address.postcode}}</p>
            </div>
          </ng-template>

        <div class="col-md-12 clear-all margin-top-30">

          <div class="col-md-5 clear-all">
            <app-contactNo [pageName]="'register'" [parent]="registrationDetailForm" [controllerData]="mobilePhoneCodeConfig" formControlName="mobilePhone"
              [controlName]="'mobilePhone'" (onChangeHandler)="txtChange()">
            </app-contactNo>
          </div>
        </div>
       
        <div class="col-md-12 clear-all margin-top-30">
          <app-email [pageName]="'register'" [parent]="registrationDetailForm" [controllerData]="emailTextCodeConfig" [controlName]="'emailAddress'" 
          [loggedInFlag]="loginDetails && loginDetails.customer.registrationStatus"
            formControlName="emailAddress" (onChangeHandler)="txtChange()">
          </app-email>
        </div>
              
        <div class="col-md-12 clear-all margin-top-30">
          <app-email [pageName]="'register'" [parent]="registrationDetailForm" [controllerData]="confirmEmailTextCodeConfig" [controlName]="'confirmEmailAddress'" 
            formControlName="confirmEmailAddress" (onChangeHandler)="txtChange()">
          </app-email>
        </div>

          <ng-container *ngIf="loginDetails && loginDetails.customer.registrationStatus">

            <div class="col-md-12 clear-all margin-top-30">
              <p class="question-font">Password</p>
            </div>
            <div class="col-md-12 clear-all">
              <a (click)="updatePassword()" blank="" role="button" tabindex="0">{{contentData.updatePwd}}</a>
            </div>
          </ng-container>
          <div class="col-md-12 clear-all margin-top-30">
            <div class="accessibiltySection" id="accessibiltySection">
              {{accessibilityTitle}}
            </div>
            <div class="accessibiltyCopy" id="accessibiltyCopy">
              <p [innerHTML]="accessibilityCopy">
            </div>
          </div>
          <div *ngIf="router.url === '/home/registration'" class="col-md-12 clear-all margin-top-30">
            <div class="accessibiltySection margin-bottom-30" id="accessibiltySection">{{marketingPermission}}</div>
            <div class="question-font" id="marketingConsentDesc">
              {{contentData.marketingConsentDesc}}
            </div>
            <!-- <div [ngClass]="disableMarketingConsent ? 'noAction col-md-12 clear-all checkboxAlign' : 'col-md-12 clear-all checkboxAlign'">
              <div class="col-md-1 Rectangle-checkbox margin-top-30">
                <input type="checkbox" id="internalSoftOptInInd" class="form-control" formControlName="internalSoftOptInInd" aria-invalid="false"
                (change)="checkMarketingConsent(registrationDetailForm.controls['internalSoftOptInInd'].value,'internalSoftOptInInd')"
                [checked]="isChecked()"
                />
              
              </div>
              <div id="marketingConsentText" [ngClass]="disableMarketingConsent ? 'col-md-11 noAction question-font mcTextAlign' : 'col-md-11 question-font mcTextAlign'" >
                  {{contentData.marketingConsentText}}
              </div>
            </div> -->

            <div class="marketing-consent-container">
              <div [ngClass]="disableMarketingConsent ? 'noAction checkbox-div' : 'checkbox-div'">
                <!-- <input type="checkbox" id="my-checkbox"> -->
                <input type="checkbox" id="internalSoftOptInInd" class="form-control"
                  formControlName="internalSoftOptInInd" aria-invalid="false"
                  (change)="checkMarketingConsent(registrationDetailForm.controls['internalSoftOptInInd'].value,'internalSoftOptInInd')"
                  [checked]="isChecked()">
              </div>
              <div
                [ngClass]="disableMarketingConsent ?  'noAction question-font text-div ' : ' question-font text-div'">
                {{contentData.marketingConsentText}}
              </div>
            </div>


          </div>
        </div>

        <div class="col-md-12 underline margin-top">
        </div>

        <div class="col-md-12 clear-all ">
          <div class="bottom-container">
            <div class="float-right btn-pading">
              <button *ngIf="loadingFlag" class="btn btn-cta btn-loading btn-opacity " type="button">
                <span class="btn-text">Primary button</span>
                <div class="spinner spinner-white">
                  <div class="spinner-ring" aria-hidden="true"></div>
                  <span class="access">Loading...</span>
                </div>
              </button>
              <div class="col-md-12 clear-all">
                <div class="float-right" *ngIf="!loadingFlag">
                  <app-content-bottom-nav [disabled]="isDisabledCTA" (onNextHandler)="createAccount()"
                    [userInputDetail]="registerButtonConfig" [buttonType]="'normalCTA'"></app-content-bottom-nav>
                </div>
                <app-modal *ngIf="proceedFlag" [modalConfig]="updatedModal" (closeModal)="closeModal_Updated()"
                  (primaryBtnClick)="proceedClick()" (secondaryBtnClick)="alertSecondaryBtnClick()"
                  [saveDataFlag]="false"></app-modal>
                <ng-container *ngIf="showModalForCardRefresh">
                  <app-modal [modalConfig]="alertCardRefreshModalConfig" (closeModal)="closeCardRefreshModal()"
                    (primaryBtnClick)="alertPrimaryBtnClickinModal()"
                    (secondaryBtnClick)="alertSecondaryCardRefreshBtnClick()" [saveDataFlag]="false"></app-modal>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>